module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu_gentei-4d24af5463c3afd78f130ce76ac899b1.png";